import { Box } from '@mui/material';

import { canFlag, internationalGlobe, ukFlag, usaFlag } from '@/images';

// Accept both 2-letter and 3-letter versions of region codes
const FLAG_MAP = {
  CAN: canFlag,
  USA: usaFlag,
  GBR: ukFlag,
  CA: canFlag,
  US: usaFlag,
  GB: ukFlag,
  Global: internationalGlobe,
} as const;

interface FlagIconProps {
  region?: string;
  width?: number;
}

export const FlagIcon = ({ region, width = 20 }: FlagIconProps) => {
  if (!region || !Object.keys(FLAG_MAP).includes(region)) {
    return null;
  }

  return (
    <Box
      component="img"
      alt={region + ' flag'}
      src={FLAG_MAP[region as keyof typeof FLAG_MAP]}
      sx={{ width, borderRadius: '2px', overflow: 'hidden' }}
    />
  );
};
